import { css } from 'aphrodite';
import * as React from 'react';
import openCompanyDataBookGraphic from '../../../assets/open-company-data-book.svg';
import openContactDataBookGraphic from '../../../assets/open-contact-data-book.svg';
import { ResourceTablePlaceholder } from '../../ResourceTablePlaceholder';
import { styleSheet } from './styles';

interface IProps {
	className?: string;
	hideClearButton?: boolean;
	message?: React.ReactNode;
	onClearButtonClicked?(): void;
	type: 'contact' | 'company' | 'tag';
}

export const EntityTablePlaceholder: React.FC<IProps> = props => {
	const { className, onClearButtonClicked, type, hideClearButton, message } = props;
	const computedClass = `${css(styleSheet.container)} entity-table-placeholder ${className || ''}`;

	return (
		<ResourceTablePlaceholder
			className={computedClass}
			emptyMessage={message}
			emptyText='We did not find anyone matching your search criteria.'
			icon={
				type === 'contact' ? (
					<img src={openContactDataBookGraphic} alt='No results found' />
				) : type === 'company' ? (
					<img src={openCompanyDataBookGraphic} alt='No results found' />
				) : (
					<img src={openCompanyDataBookGraphic} alt='No results found' />
				)
			}
			hideClearButton={hideClearButton}
			onClearButtonClicked={onClearButtonClicked}
		/>
	);
};
